<template>
  <article class="garage-gallery">
    <Carousel
      :mouse-drag="garageImages.length > 1"
      :touch-drag="garageImages.length > 1"
      :wrap-around="true"
    >
      <Slide
        v-for="image in sortedGarageImages"
        :key="image.id"
      >
        <NuxtImg
          loading="lazy"
          class="garage-gallery__photo"
          height="auto"
          format="webp, avif"
          :src="image.url"
          :alt="image.title || ''"
        />
      </Slide>

      <template
        v-if="garageImages.length > 1"
        #addons
      >
        <Navigation />
      </template>
    </Carousel>
  </article>
</template>

<script setup lang="ts">
import type { GarageImageJsonldGarageImageRead } from '~/api/docs/api';
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel';

interface IProps {
  garageImages: GarageImageJsonldGarageImageRead[];
}

const props = defineProps<IProps>();

const sortedGarageImages: Ref<GarageImageJsonldGarageImageRead[]> = computed(() => {
  return props.garageImages.sort((a, b) => {
    return (a.primary === b.primary) ? 0 : a.primary ? -1 : 1;
  });
})

</script>

<style lang="scss">
@import url('assets/styles/components/garage-gallery.scss');
</style>